import AppHeader from 'src/components/AppHeader/AppHeader';
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';

export default function NotFoundPage() {

  const navigate = useNavigate();

  return (
      <>
        <AppHeader/>
        <Stack
            direction='column'
            spacing={3}
            sx={{ justifyContent: 'center', alignItems: 'center', height: `calc(100vh - 64px)` }}
        >
          <Typography sx={{ fontSize: '8rem', fontWeight: 700, lineHeight: 1, color: theme.palette.primary.main }}>
            404
          </Typography>
          <Stack direction='column' spacing={1} sx={{ justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant='h5'>
              {ts('not_found_title', 'Page not found')}
            </Typography>
            <Typography variant='body1' sx={{ color: theme.palette.text.secondary, maxWidth: 480 }}>
              {ts('not_found_text', "The page you're looking for doesn't exist or may have moved.")}
            </Typography>
          </Stack>
          <Button variant='contained' onClick={() => navigate('/')}>
            {ts('not_found_back_home', 'Back to Home')}
          </Button>
        </Stack>
      </>
  );
}